<template>
  <v-footer id="app-footer" app inset absolute width="auto" height="auto">
    <v-row no-gutters justify="center" class="py-3">
      <v-btn
        v-for="link in links"
        :key="link.text"
        :href="link.href"
        text
        small
        class="my-0 ml-2"
        color="primary"
        target="_blank"
      >
        {{ link.text }}
      </v-btn>
      <v-col cols="12" class="text-center mt-2">
        All text and design is copyright &copy; {{ new Date().getFullYear() }} WhaleWisdom.com. All
        rights reserved.
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      {
        text: 'Disclaimer',
        href: '/info/disclaimer'
      },
      {
        text: 'Privacy Policy',
        href: '/info/privacy_policy'
      },
      {
        text: 'Trademarks',
        href: '/info/trademarks'
      },
      {
        text: 'LIMIT THE USE OF MY SENSITIVE PERSONAL INFORMATION',
        href: '/info/ccpa_notice'
      }
    ]
  })
}
</script>
